(() => {
  "use strict";

  const root = document.querySelector("[data-aleva-product]");
  if (!root) return;

  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];

  const form = $("#AlevaProductForm");
  const variantInput = $("#AlevaVariantId");
  const quantityInput = $("#AlevaQuantityInput");
  const quantityText = $("#pdpQuantity");
  const price = $("#pdpPrice");
  const points = $("#pdpPoints");
  const selectedSize = $("#pdpSelectedSize");
  const addButton = $("#pdpAddToCart");
  const addLabel = $("#pdpAddLabel");
  const toast = $("#pdpToast");
  const wishlist = $("#pdpWishlist");
  const sizeButtons = $$(".pdp-size", root);

  let quantity = 1;
  let currentSlide = 0;
  let touchStartX = 0;
  let toastTimer;

  const translationsNode =
    document.getElementById("AlevaProductTranslations");

  let translations = {};

  try {
    translations = JSON.parse(
      translationsNode?.textContent || "{}"
    );
  } catch {
    translations = {};
  }

  const translationKeyMap = {
    "collection.soldOut": "soldOut",
    "product.addToCart": "addToCart",
    "product.points": "points",
    "product.showProfile": "showProfile",
    "product.showProduct": "showProduct",
    "product.addWishlist": "addWishlist",
    "product.removeWishlist": "removeWishlist",
    "product.reduceQuantity": "reduceQuantity",
    "product.increaseQuantity": "increaseQuantity",
    "product.prevImage": "previousImage",
    "product.nextImage": "nextImage",
    "product.addedToCart": "addedToCart"
  };

  function currentLanguage() {
    return (
      translations.language ||
      document.documentElement.lang ||
      "de"
    ).toLowerCase();
  }

  function tr(key) {
    const bridgeKey = translationKeyMap[key];

    if (!bridgeKey) return key;

    return translations[bridgeKey] || key;
  }

  function tpl(value, variables = {}) {
    let output = String(value);

    if (Object.prototype.hasOwnProperty.call(variables, "points")) {
      output = output.replace(
        /__POINTS__/g,
        String(variables.points ?? "")
      );
    }

    return output.replace(
      /{(\w+)}/g,
      (_, key) => variables[key] ?? ""
    );
  }

  function soldOutText() {
    const translated = tr("collection.soldOut");

    if (translated !== "collection.soldOut") {
      return translated;
    }

    if (currentLanguage().startsWith("ar")) {
      return "غير متوفر";
    }

    if (currentLanguage().startsWith("en")) {
      return "SOLD OUT";
    }

    return "AUSVERKAUFT";
  }

  function productName() {
    return $("#pdpName")?.textContent?.trim() || "";
  }

  function activeSizeButton() {
    return $(".pdp-size.is-active", root);
  }

  function activeVariantAvailable() {
    return activeSizeButton()?.dataset.available === "true";
  }

  function syncAddToCartLabel() {
    if (!addLabel) return;
    addLabel.textContent = activeVariantAvailable()
      ? tr("product.addToCart")
      : soldOutText();
  }

  function syncPoints() {
    const active = activeSizeButton();
    if (!active || !points) return;

    points.textContent = tpl(
      tr("product.points"),
      { points: active.dataset.points || 0 }
    );
  }

  function syncGalleryReveal() {
    const reveal = $("#pdpGalleryReveal");
    if (!reveal) return;

    const label = reveal.querySelector("span:first-child");
    const symbol = reveal.querySelector("span:last-child");

    if (label) {
      label.textContent =
        currentSlide === 0
          ? tr("product.showProfile")
          : tr("product.showProduct");
    }

    if (symbol) {
      symbol.textContent = currentSlide === 0 ? "+" : "−";
    }
  }

  function syncWishlistAria() {
    if (!wishlist) return;

    const isActive = wishlist.classList.contains("is-active");

    wishlist.setAttribute(
      "aria-label",
      tr(isActive ? "product.removeWishlist" : "product.addWishlist")
    );
  }

  function syncInteractiveTranslations() {
    syncAddToCartLabel();
    syncPoints();
    syncGalleryReveal();
    syncWishlistAria();

    $("#pdpMinus")?.setAttribute(
      "aria-label",
      tr("product.reduceQuantity")
    );

    $("#pdpPlus")?.setAttribute(
      "aria-label",
      tr("product.increaseQuantity")
    );

    $("#pdpPrev")?.setAttribute(
      "aria-label",
      tr("product.prevImage")
    );

    $("#pdpNext")?.setAttribute(
      "aria-label",
      tr("product.nextImage")
    );
  }

  function setQuantity(next) {
    quantity = Math.max(1, Number(next) || 1);

    if (quantityInput) {
      quantityInput.value = String(quantity);
    }

    if (quantityText) {
      quantityText.textContent = String(quantity);
    }
  }

  $("#pdpMinus")?.addEventListener(
    "click",
    () => setQuantity(quantity - 1)
  );

  $("#pdpPlus")?.addEventListener(
    "click",
    () => setQuantity(quantity + 1)
  );

  function selectVariant(button, updateUrl = true) {
    if (!button) return;

    sizeButtons.forEach(btn => {
      const active = btn === button;

      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", String(active));
    });

    const variantId = button.dataset.variantId;
    const available = button.dataset.available === "true";

    if (variantInput) {
      variantInput.value = variantId;
    }

    if (selectedSize) {
      selectedSize.textContent =
        button.dataset.variantTitle ||
        button.textContent.trim();
    }

    if (price) {
      price.textContent =
        button.dataset.priceFormatted ||
        price.textContent;
    }

    if (addButton) {
      addButton.disabled = !available;
    }

    syncPoints();
    syncAddToCartLabel();

    if (updateUrl && variantId && window.history?.replaceState) {
      const url = new URL(window.location.href);

      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url.toString());
    }
  }

  sizeButtons.forEach(button => {
    button.addEventListener(
      "click",
      () => selectVariant(button)
    );
  });

  function showToast(message) {
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add("is-visible");

    clearTimeout(toastTimer);

    toastTimer = setTimeout(
      () => toast.classList.remove("is-visible"),
      2200
    );
  }

  async function refreshCartCount() {
    const syncCartBadge =
      window.ALEVA_SYNC_CART_BADGE;

    if (typeof syncCartBadge === "function") {
      await syncCartBadge();
    }
  }

  function genericAddError() {
    if (translations.addError) {
      return translations.addError;
    }

    if (currentLanguage().startsWith("ar")) {
      return "تعذر إضافة المنتج إلى السلة.";
    }

    if (currentLanguage().startsWith("en")) {
      return "The product could not be added to the cart.";
    }

    return "Produkt konnte nicht zum Warenkorb hinzugefügt werden.";
  }

  form?.addEventListener("submit", async event => {
    event.preventDefault();

    if (!variantInput?.value || addButton?.disabled) {
      return;
    }

    addButton?.classList.add("is-loading");

    if (addButton) {
      addButton.disabled = true;
    }

    if (addLabel) {
      addLabel.textContent = "…";
    }

    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || "/"}cart/add.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantInput.value),
                quantity
              }
            ]
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          genericAddError()
        );
      }

      await refreshCartCount();

      showToast(
        tpl(
          tr("product.addedToCart"),
          { name: productName() }
        )
      );

      setQuantity(1);

    } catch (error) {
      showToast(
        error?.message ||
        genericAddError()
      );

    } finally {
      addButton?.classList.remove("is-loading");

      const available = activeVariantAvailable();

      if (addButton) {
        addButton.disabled = !available;
      }

      syncAddToCartLabel();
    }
  });

  /* ==============================
     Gallery
  ============================== */

  const gallery = $("#pdpGallery");
  const slides = $$(".pdp-slide", gallery || document);
  const dots = $$(".pdp-dot", gallery || document);
  const reveal = $("#pdpGalleryReveal");

  let galleryRequest = 0;

  function hydrateSlide(index) {
    const slide = slides[index];
    if (!slide) return Promise.resolve(false);

    const image = slide.querySelector("img[data-gallery-lazy='true']");
    if (!image) return Promise.resolve(true);

    if (image.dataset.galleryLoaded === "true") {
      return Promise.resolve(true);
    }

    const src = image.dataset.gallerySrc;
    const srcset = image.dataset.gallerySrcset;

    if (!src && !srcset) {
      return Promise.resolve(false);
    }

    return new Promise(resolve => {
      let settled = false;

      const cleanup = () => {
        image.removeEventListener("load", onLoad);
        image.removeEventListener("error", onError);
      };

      const finish = async success => {
        if (settled) return;

        settled = true;
        cleanup();

        if (!success) {
          image.removeAttribute("src");
          image.removeAttribute("srcset");
          resolve(false);
          return;
        }

        image.dataset.galleryLoaded = "true";
        image.removeAttribute("data-gallery-src");
        image.removeAttribute("data-gallery-srcset");

        if (image.decode) {
          await image.decode().catch(() => {});
        }

        resolve(true);
      };

      const onLoad = () => finish(true);
      const onError = () => finish(false);

      image.addEventListener("load", onLoad, { once: true });
      image.addEventListener("error", onError, { once: true });

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }

      if (image.complete) {
        queueMicrotask(() => finish(image.naturalWidth > 0));
      }
    });
  }

  async function showSlide(index) {
    if (!slides.length) return;

    const nextSlide =
      (index + slides.length) %
      slides.length;

    if (nextSlide === currentSlide) {
      return;
    }

    const requestId = ++galleryRequest;

    gallery?.classList.add("is-gallery-loading");

    /*
      Keep the current image visible while the requested image downloads.
      The second image therefore consumes zero data until the visitor
      actually uses an arrow, dot, swipe or "Duftprofil anzeigen".
    */
    const slideLoaded = await hydrateSlide(nextSlide);

    if (requestId !== galleryRequest) {
      return;
    }

    gallery?.classList.remove("is-gallery-loading");

    if (!slideLoaded) {
      syncGalleryReveal();
      return;
    }

    currentSlide = nextSlide;

    slides.forEach((slide, i) => {
      slide.classList.toggle(
        "is-active",
        i === currentSlide
      );
    });

    dots.forEach((dot, i) => {
      dot.classList.toggle(
        "is-active",
        i === currentSlide
      );

      dot.setAttribute(
        "aria-current",
        i === currentSlide
          ? "true"
          : "false"
      );
    });

    syncGalleryReveal();
  }

  $("#pdpPrev")?.addEventListener(
    "click",
    () => showSlide(currentSlide - 1)
  );

  $("#pdpNext")?.addEventListener(
    "click",
    () => showSlide(currentSlide + 1)
  );

  reveal?.addEventListener(
    "click",
    () => showSlide(currentSlide + 1)
  );

  dots.forEach(dot => {
    dot.addEventListener(
      "click",
      () => showSlide(
        Number(dot.dataset.pdpSlide)
      )
    );
  });

  // Record the primary touch without interfering with normal page scrolling.
  let gallerySwipe = null;
  gallery?.addEventListener("touchstart", event => {
    if (event.touches.length !== 1 || !event.target.closest(".pdp-slide")) {
      gallerySwipe = null;
      return;
    }
    const touch = event.touches[0];
    gallerySwipe = { x: touch.clientX, y: touch.clientY, valid: true };
  }, { passive: true });

  gallery?.addEventListener("touchmove", event => {
    if (!gallerySwipe) return;
    if (event.touches.length !== 1) {
      gallerySwipe.valid = false;
      return;
    }
    const touch = event.touches[0];
    const dx = touch.clientX - gallerySwipe.x;
    const dy = touch.clientY - gallerySwipe.y;
    if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 12) {
      gallerySwipe.valid = false;
    }
  }, { passive: true });

  gallery?.addEventListener("touchend", event => {
    const swipe = gallerySwipe;
    gallerySwipe = null;
    if (!swipe?.valid || event.changedTouches.length !== 1 || event.touches.length) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - swipe.x;
    const dy = touch.clientY - swipe.y;
    if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      showSlide(currentSlide + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });

  gallery?.addEventListener("touchcancel", () => { gallerySwipe = null; }, { passive: true });

  /* ==============================
     Wishlist
  ============================== */

  const wishlistKey =
    "aleva-wishlist-products";

  function readWishlist() {
    try {
      return JSON.parse(
        localStorage.getItem(wishlistKey) ||
        "[]"
      );
    } catch {
      return [];
    }
  }

  function updateWishlist() {
    if (!wishlist) return;

    const id = root.dataset.productId;
    const active =
      readWishlist().includes(id);

    wishlist.classList.toggle(
      "is-active",
      active
    );

    wishlist.setAttribute(
      "aria-pressed",
      String(active)
    );

    syncWishlistAria();
  }

  wishlist?.addEventListener("click", () => {
    const id = root.dataset.productId;
    let items = readWishlist();

    items =
      items.includes(id)
        ? items.filter(item => item !== id)
        : [...items, id];

    localStorage.setItem(
      wishlistKey,
      JSON.stringify(items)
    );

    updateWishlist();
  });

  /* When ALEVA language changes, refresh all text that this
     interactive product script controls. */
  document.addEventListener(
    "aleva:languagechange",
    syncInteractiveTranslations
  );

  updateWishlist();
  showSlide(0);
  syncInteractiveTranslations();
})();
